import React from 'react';
import RotatingSalesModal from './RotatingSalesModal'; // Adjust path as needed
import './images/PoolServiceHomepage.css'; // For background image styling

const PoolServiceHomepage = () => {
    return (
        <div className="pool-homepage-background">
            <RotatingSalesModal />
        </div>
    );
};

export default PoolServiceHomepage;
